<div class="layout">
    <app-header (emitChangeMenu)="onChangeMenuState()"></app-header>
    <app-content [stateMenu]="stateMenu" [ngClass]="marginClass" (emitChangeMenu)="onChangeMenuState()">
        <ng-content></ng-content>
    </app-content>
    <app-footer *ngIf="showFooter"></app-footer>
</div>
